import * as types from './types';

const INITIAL_STATE = {
  loadingSetUp: false,
  setUpData: [],
  loadingSetUpError: null,

  isSetUpSubmitting: false,
  submitted: false,
  submitError: null,
  submitSuccessMsg: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.INVENTORY_BASIC_SETUP_LOADING:
      return { ...state, loadingSetUp: action.payload };

    case types.INVENTORY_BASIC_SETUP_DATA:
      return {
        ...state,
        setUpData: action.payload.data.Data,
      };

    case types.INVENTORY_BASIC_SETUP_LOADING_ERROR:
      return {
        ...state,
        loadingSetUpError: action.payload,
      };

    case types.INVENTORY_BASIC_SUBMITTING:
      return { ...state, isSetUpSubmitting: action.payload };

    case types.INVENTORY_BASIC_SUBMITTED:
      return {
        submitted: true,
        submitSuccessMsg: action.payload.data.Data,
      };

    case types.INVENTORY_BASIC_SUBMITTING_ERROR:
      return {
        ...state,
        submitError: action.payload,
      };

    case types.INVENTORY_BASIC_SETUP_CLEAR:
      return {
        loadingSetUp: false,
        loadingSetUpError: null,
        isSetUpSubmitting: false,
        submitted: false,
        submitError: null,
        submitSuccessMsg: '',
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorybasicsetup/state/reducer.js